import { extractSponsorCode, getFieldConfig } from './advisorCodeUtils';
import { get } from 'lodash';

export type AdvisorLabels = {
  formErrors?: {
    reqSponsorCode?: string;
    invalidSponsorCode?: string;
    reqPartyId?: string;
    invalidPartyId?: string;
    reqCounsellorId?: string;
    alreadyLinkedPartyId?: string;
    alreadyLinkedCounsellorId?: string;
    invalidCounsellorId?: string;
  };
  form?: {
    partyIdLabel?: string;
    counsellerIdModal?: string;
  };
};

export type FormValues = {
  sponsorCode: string;
  partyId: string;
  counselorId: string;
};

export const INITIAL_FORM_VALUES: FormValues = {
  sponsorCode: '',
  partyId: '',
  counselorId: ''
};

const SIGNED_32BIT_INT_EXPONENT = 31;
const MAX_SIGNED_32BIT_INTEGER = Math.pow(2, SIGNED_32BIT_INT_EXPONENT) - 1;

export const validateForm = (
  values: FormValues,
  sponsors: { displayName: string; value: string }[],
  labels: AdvisorLabels = {}
) => {
  const errors: Partial<FormValues> = {};
  if (!values.sponsorCode) {
    errors.sponsorCode = get(labels, 'formErrors.reqSponsorCode');
    return errors;
  }

  const selectedSponsor = sponsors.find(sponsor => sponsor.value === values.sponsorCode);
  const extractedCode = extractSponsorCode(selectedSponsor?.displayName || values.sponsorCode);
  const { isMLIADV } = getFieldConfig(extractedCode, labels);

  if (isMLIADV) {
    if (!values.partyId) {
      errors.partyId = get(labels, 'formErrors.reqPartyId');
    } else {
      if (Number(values.partyId) >= MAX_SIGNED_32BIT_INTEGER) {
        errors.partyId = get(labels, 'formErrors.invalidPartyId');
      }
    }
  } else {
    if (!values.counselorId) {
      errors.counselorId = get(labels, 'formErrors.reqCounsellorId');
    }
  }

  return errors;
};
